(() => {
  const init = (root) => {
    if (root.dataset.quizReady) return;
    root.dataset.quizReady = 'true';
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => Array.from(root.querySelectorAll(selector));
    const strings = JSON.parse($('[data-quiz-strings]').textContent);
    const chart = JSON.parse($('[data-quiz-chart]').textContent);
    const total = Number(root.dataset.totalSteps);
    const funnel = root.closest('[data-funnel]')?.dataset.funnel || 'quiz';
    const track = (event, data = {}) => window.funnelTrack?.(event, { funnel, ...data });
    const screens = $$('[data-quiz-screen]');
    const order = screens.map((screen) => screen.dataset.quizScreen);
    const fill = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`[${key}]`, value), template || '');
    let history = [];
    let current = 'intro';
    let state = { breed: null, chest: null, source: null, answers: new Map() };

    const show = (name) => {
      current = name;
      screens.forEach((screen) => { screen.hidden = screen.dataset.quizScreen !== name; });
      const screen = screens.find((item) => item.dataset.quizScreen === name);
      const step = Number(screen.dataset.quizStep || 0);
      $('[data-quiz-progress]').hidden = !step;
      if (step) {
        const percent = Math.round((step - 1) / total * 100);
        $('[data-quiz-bar]').style.width = `${percent}%`;
        $('[role="progressbar"]').setAttribute('aria-valuenow', String(percent));
        $('[data-quiz-count]').textContent = fill(strings.count, { current: step, total });
      }
      screen.querySelector('.funnel-quiz__question')?.focus({ preventScroll: true });
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };
    const go = (name) => { history.push(current); show(name); };
    const next = () => {
      const upcoming = order[order.indexOf(current) + 1];
      if (upcoming !== 'loading') return go(upcoming);
      go('loading');
      setTimeout(showResult, 1100);
    };

    const recommend = (chest) => {
      const matches = chart.filter((row) => chest >= row.chestMin && chest <= row.chestMax);
      // Same rule as the product page fit studio: most clearance inside the range, larger size on a tie.
      const clearance = (row) => Math.min(chest - row.chestMin, row.chestMax - chest) / (row.chestMax - row.chestMin);
      const size = matches.slice().sort((a, b) => clearance(b) - clearance(a) || chart.indexOf(b) - chart.indexOf(a))[0];
      return { size, between: matches.length > 1 };
    };

    const showResult = () => {
      const { size, between } = recommend(state.chest);
      const breedName = state.breed?.name || strings.yourDog;
      const link = $('[data-funnel-cta]');
      $('[data-quiz-size-box]').hidden = !size;
      if (size) {
        $('[data-quiz-result-title]').textContent = fill(strings.resultTitle, { breed: breedName });
        $('[data-quiz-size]').textContent = size.size;
        const chest = Math.round(state.chest * 10) / 10;
        $('[data-quiz-size-reason]').textContent = (state.source === 'breed' ? fill(strings.fromBreed, { breed: breedName, chest }) : fill(strings.fromMeasure, { chest })) + (between ? ` ${strings.between}` : '');
        $('[data-quiz-ranges]').textContent = fill(strings.ranges, { size: size.size, chestMin: size.chestMin, chestMax: size.chestMax, neckMin: size.neckMin, neckMax: size.neckMax });
      } else {
        $('[data-quiz-result-title]').textContent = strings.noFitTitle;
      }
      $('[data-quiz-no-fit]').hidden = !!size;

      const answers = Array.from(state.answers.values());
      const tips = [...new Set([strings.baseTip, ...answers.map((input) => input.dataset.tip)].filter(Boolean))];
      $('[data-quiz-tips]').replaceChildren(...tips.map((tip) => Object.assign(document.createElement('li'), { textContent: tip })));
      const patch = answers.map((input) => input.dataset.patch).find(Boolean);
      $('[data-quiz-patch-box]').hidden = !patch;
      $('[data-quiz-patch]').textContent = patch || '';

      if (link) {
        const url = new URL(root.dataset.productUrl, window.location.origin);
        if (size) url.searchParams.set('fit', size.size);
        link.href = window.funnelLink ? window.funnelLink(url.pathname + url.search) : url.pathname + url.search;
        link.textContent = size ? fill(strings.cta, { size: size.size }) : strings.ctaNoFit;
      }
      // Preselect the recommended size in the offer's buy form, so only the colour is left to choose.
      if (size) $('[data-funnel-buy]')?.funnelSelectSize?.(size.size);
      track('quiz_complete', { size: size?.size || 'no_fit', chest_source: state.source });
      history = [];
      show('result');
    };

    $('[data-quiz-start]').addEventListener('click', () => { track('quiz_start'); go('breed'); });
    $('[data-quiz-back]').addEventListener('click', () => { if (history.length) show(history.pop()); });

    $$('[data-quiz-breed]').forEach((input) => input.addEventListener('change', () => {
      state.breed = input.value ? { name: input.value, chest: (Number(input.dataset.chestMin) + Number(input.dataset.chestMax)) / 2 } : null;
      $('[data-quiz-estimate]').hidden = !state.breed;
      track('quiz_step', { step: 1, question: 'breed', answer: input.value || 'other' });
      setTimeout(next, 180);
    }));

    const chestInput = $('[data-quiz-chest]');
    $('[data-quiz-measure-next]').addEventListener('click', () => {
      const chest = Number(chestInput.value);
      const valid = chestInput.value !== '' && chest >= 20 && chest <= 130;
      $('[data-quiz-chest-error]').hidden = valid;
      chestInput.setAttribute('aria-invalid', String(!valid));
      if (!valid) { chestInput.focus(); return; }
      state.chest = chest;
      state.source = 'measure';
      track('quiz_step', { step: 2, question: 'measure', answer: 'measured' });
      next();
    });
    $('[data-quiz-estimate]').addEventListener('click', () => {
      if (!state.breed) return;
      state.chest = state.breed.chest;
      state.source = 'breed';
      track('quiz_step', { step: 2, question: 'measure', answer: 'estimate' });
      next();
    });

    $$('[data-quiz-answer]').forEach((input) => input.addEventListener('change', () => {
      const screen = input.closest('[data-quiz-screen]');
      state.answers.set(screen.dataset.question, input);
      track('quiz_step', { step: Number(screen.dataset.quizStep), question: screen.dataset.question, answer: input.value });
      setTimeout(next, 180);
    }));

    $('[data-quiz-restart]').addEventListener('click', () => {
      $$('input[type="radio"]').forEach((input) => { input.checked = false; });
      $('[data-funnel-buy] [data-variant-picker] input')?.dispatchEvent(new Event('change', { bubbles: true }));
      chestInput.value = '';
      state = { breed: null, chest: null, source: null, answers: new Map() };
      history = [];
      track('quiz_restart');
      show('breed');
    });
  };

  const scan = (scope) => scope.querySelectorAll('[data-quiz]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
